





















































































































































































































































































































































































































import Vue from "vue";
import Confirm from "../../components/confirmation/confirm.vue";
import moment from "moment";
export default Vue.extend({
  components: {
    Confirm,
  },

  data: () => ({
    sortCond: true,
    show: true,
    jobs: [],
    dataLoading: false,
    sortBy_arr: ["Newest Date", "Oldest Date"],
    sortByValue: "",
    newArray: [],
    searchValue: "",
    sortBy: "name",
    sortDirection: "asc",
    search: "",
    headers: [
      {
        text: "Title",
        align: "start",
        sortable: false,
        value: "job_title",
      },
      { text: "Applicants", value: "calories" },
      { text: "Shortlisted", value: "fat" },
      { text: "Invited", value: "carbs" },
      { text: "Actions", value: "protein" },
    ],
  }),

  created() {
    this.all_job();
  },

  computed: {
    sortedProducts: function () {
      return this.products.sort((p1, p2) => {
        let modifier = 1;
        if (this.sortDirection === "desc") modifier = -1;
        if (p1[this.sortBy] < p2[this.sortBy]) return -1 * modifier;
        if (p1[this.sortBy] > p2[this.sortBy]) return 1 * modifier;
        return 0;
      });
    },

    filteredJobs() {
      return this.search
        ? this.jobs.filter((job) => {
            return job.job_title
              .toLowerCase()
              .includes(this.search.toLowerCase());
          })
        : this.jobs;
    },
  },

  methods: {
    orderByCond(what, cond) {
      console.log(what);
      this.sortCond = !cond;
      return this.filteredJobs.sort((secondEl, firstEl) => {
        return this.sortCond 
        ? secondEl.number_of_candidates_applied - firstEl.number_of_candidates_applied 
        : firstEl.number_of_candidates_applied - secondEl.number_of_candidates_applied;
      });
    },


    //     orderByConds(what, cond) {
    //   console.log(what);
    //   this.sortCond = !cond;
    //   return this.filteredJobs.sort((secondEl, firstEl) => {
    //     return this.sortCond 
    //     ? secondEl.number_of_candidates_invited - firstEl.number_of_candidates_invited 
    //     : firstEl.number_of_candidates_invited - secondEl.number_of_candidates_invited;
    //   });
    // },

    sort: function (s) {
      if (s === this.sortBy) {
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      }
      this.sortBy = s;
    },

    async all_job() {
      let token = localStorage.getItem("jwt");
      let userId = localStorage.getItem("userId");
      this.dataLoading = true;
      if (token && userId) {
        const auth = {
          headers: { authorization: token },
        };
        let resp = await this.$http.get(
          "job/fetchJobsByRecruiter/" + userId,
          auth
        );
        console.log(resp);
        if (resp.status === 200 && resp.data.message === "Jobs found") {
          this.jobs = resp.data.jobs;
          console.log("jobs: ", this.jobs);
          for (let i = 0; i < this.jobs.length; i++) {
            for (let j = 0; j < this.jobs[i].exam_dates.length; j++) {
              var day = moment.unix(this.jobs[i].exam_dates[j]);
              this.jobs[i].exam_dates[j] = day.format("MMMM Do YYYY, h:mm a");
            }
          }
        }
        this.dataLoading = false;
      }
    },

    go_to_talent(id) {
      this.$router.push({ name: "recomended_talent", params: { id: id } });
    },

    go_to_applicants(id) {
      this.$router.push({ name: "applied_candidate", params: { id: id } });
    },

    go_to_invite(id) {
      this.$router.push({ name: "invite_talent", params: { id: id } });
    },

    go_to_shorListed(id) {
      this.$router.push({ name: "shortlist_candidate", params: { id: id } });
    },

    go_to_jdetails(jid) {
      this.$router.push({
        name: "job-application-details",
        params: { id: jid },
      });
    },

    edit(jid) {
      this.$router.push({
        name: "update_job-application",
        params: { id: jid },
      });
    },
    async job_delete(id) {
      try {
        this.$swal({
          title: "Remove Application",
          text: "Are you sure?",
          icon: "info",
          showCancelButton: true,
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          customClass: "swal-title-jobapplication",
        }).then((result) => {
          if (result.isConfirmed) {
            this.delete_job(id);
          }
        });
      } catch (error) {}
    },

    async delete_job(id) {
      let token = localStorage.getItem("jwt");
      let userId = localStorage.getItem("userId");

      console.log(token);
      console.log(userId);

      if (token && userId) {
        const auth = {
          headers: { authorization: token },
        };
        let res = await this.$http.post(
          "/job/removeJob",
          {
            job_id: id,
            user_id: userId,
          },
          auth
        );
        if (
          res.status === 200 &&
          res.data.message === "Job removed successfully"
        ) {
          console.log("jhjhggyugyggygy");
          this.snackbar = true;
          this.showMessage = "Removed Successfully.";
          this.all_job();
        } else {
          this.snackbar = true;
          this.showMessage = "Something wrong! Please try again.";
        }
      }
    },
    onChange() {
      console.log("date", this.sortByValue);
      let changeArr = this.jobs.slice(0);
      if (this.sortByValue != "Newer Date") {
        this.jobs = changeArr.reverse();
        console.log("changeArr", changeArr);
      } else {
        this.jobs = this.newArray;
      }
    },

    up() {
      let changeArr = this.newArray.slice(0);
      if (this.searchValue.length > 2) {
        const filteredData = changeArr.filter((value) => {
          const searchStr = this.searchValue.toLowerCase();
          const nameMatches = value.job_title.toLowerCase().includes(searchStr);
          return nameMatches;
        });
        this.jobs = filteredData;
        console.log("filteredData", this.jobs);
      } else {
        this.jobs = this.newArray;
      }
    },
  },
});
